<template>
  <bar-chart
    :data="barChartData"
    :options="barChartOptions"
    style="min-height: 180px"
  ></bar-chart>
</template>

<script>
    import BarChart from "../Wrappers/barChart";
    export default {
        name: "EngagementBars",
        components: {BarChart},
        props: {
          colors: {
            type: Object
          },
          engagement: {
            type: Object
          }
        },
        computed: {
          barChartData() {
            const colors = this.colors ? Object.values(this.colors) : []
            const values = this.engagement ? Object.values(this.engagement) : []
            const datasets = [
              {
                backgroundColor: colors,
                data: values,
              }
            ]

            // const labels = this.engagement ? Object.keys(this.engagement) : []
            //
            // labels.forEach((label, index) => {
            //   datasets.push({
            //     backgroundColor: this.colors[label],
            //     label,
            //     data: [{x: label, y: this.engagement[label]}],
            //     order: index
            //   })
            // })

            return { datasets};
          },
          barChartOptions(){
            const labels = this.engagement ? Object.keys(this.engagement) : []
            return {
              responsive: true,
              legend: {
                display: false,
                position: "top"
              },
              scales: {
                xAxes: [{
                  display: true,
                  type: 'category',
                  labels,
                  gridLines: {
                    display: false,
                    color: '#eee'
                  },
                }],
                yAxes: [{
                  display: false,
                  gridLines: {
                    display: false
                  },
                  ticks: {
                    beginAtZero: true
                  }
                }]
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem) {
                    return tooltipItem.value + '%'
                  }
                }
              }
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Dashboard/EngagementBars.vue